import moment from 'moment';
import { dateUtils } from '@bringg-frontend/utils';

import { Duration } from 'bringg-web/features/planned-delivery-windows/modals/slots-modal/planned-delivery-windows-slots.consts';

// with the DST fix, start/end are subtracted as wall-clock minutes in week instead of diffing the rebuilt dates,
// which adds or drops an hour on a DST transition day
const getHours = (startTimeMinutes: number, endTimeMinutes: number, timezone: string): number => {
	if (dateUtils.isDstSafeSlotTimesEnabled()) {
		return Math.trunc((endTimeMinutes - startTimeMinutes) / dateUtils.MINUTES_IN_HOUR);
	}

	const startTimeDate = dateUtils.addMinutesToLastMonday(startTimeMinutes, timezone);
	const endTimeDate = dateUtils.addMinutesToLastMonday(endTimeMinutes, timezone);
	return endTimeDate.diff(startTimeDate, 'h');
};
const getMinutes = (startTimeMinutes: number, endTimeMinutes: number, timezone: string) => {
	if (dateUtils.isDstSafeSlotTimesEnabled()) {
		return (endTimeMinutes - startTimeMinutes) % dateUtils.MINUTES_IN_HOUR;
	}

	const startTimeDate = dateUtils.addMinutesToLastMonday(startTimeMinutes, timezone);
	const endTimeDate = dateUtils.addMinutesToLastMonday(endTimeMinutes, timezone);
	const diffInMinutes = endTimeDate.diff(startTimeDate, 'm');
	return moment(0)
		.add(diffInMinutes, 'm')
		.subtract(getHours(startTimeMinutes, endTimeMinutes, timezone), 'h')
		.minutes();
};

const getDurations = (startTimeMinutes: number, endTimeMinutes: number, timezone: string): Duration => {
	return {
		minutes: getMinutes(startTimeMinutes, endTimeMinutes, timezone),
		hours: getHours(startTimeMinutes, endTimeMinutes, timezone)
	};
};
export const durationCalculate = { getHours, getMinutes, getDurations };
